import React from "react";
import locale from "@bonliva-crm/locale";
import { Divider, Grid, IconButton } from "@material-ui/core";
import { RemoveCircleOutline } from "@material-ui/icons";
import { Text } from "@common/formx";

type Props = {
  name: string;
  onRemove: () => void;
};

export function ContactPersonForm({ name, onRemove }: Props) {
  return (
    <div style={{ position: "relative" }} key={name}>
      <IconButton
        aria-label="delete"
        onClick={onRemove}
        style={{ position: "absolute", right: 0, top: 0, zIndex: 1 }}
      >
        <RemoveCircleOutline />
      </IconButton>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Text label={`${locale.Title}`} name={`${name}.title`} key={"title"} />
        </Grid>

        <Grid item xs={12}>
          <Text label={locale.Name} name={`${name}.name`} key={"name"} />
        </Grid>

        <Grid item xs={12}>
          <Text label={locale.Email} name={`${name}.email`} key={"email"} />
        </Grid>

        <Grid item xs={12}>
          <Text label={locale.Phone} name={`${name}.phone`} key={"phone"} />
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
    </div>
  );
}
